import Repositories from 'src/repositories'
import socket from 'src/services/socket'

export async function loadSessionList ({ commit }) {
  commit('SET_SESSION_LIST', await Repositories.trainingSession.session.getList())
}

export async function joinAllOpenedSessions ({ getters }) {
  getters.openedSessionIdList
    .forEach(id => socket.emit('trainingSessionJoin', { id }))
}

export async function leaveAllOpenedSessions ({ getters }) {
  getters.openedSessionIdList
    .forEach(id => socket.emit('trainingSessionJoin', { id }))
}

export async function openSession ({ commit }, sessionId) {
  socket.emit('trainingSessionJoin', { id: sessionId })
  commit('ADD_OPENED_SESSION', sessionId)
}

export async function openSessionList ({ commit }, sessionIdList) {
  sessionIdList.forEach(id => socket.emit('trainingSessionJoin', { id }))
  commit('ADD_OPENED_SESSION_LIST', sessionIdList)
}

export async function closeSession ({ commit }, sessionId) {
  socket.emit('trainingSessionLeave', { id: sessionId })
  commit('REMOVE_OPENED_SESSION', sessionId)
}

export async function patchSession ({ commit }, { id, ...updatedFields }) {
  commit('PATCH_SESSION', { id, ...updatedFields })
}

export async function patchGame ({ commit }, { sessionId, id, ...updatedFields }) {
  commit('PATCH_GAME', { sessionId, id, ...updatedFields })
}

export async function saveLastRouteHistory ({ commit }, { sessionId, path }) {
  commit('SAVE_LAST_ROUTE_HISTORY', { sessionId, path })
}

export async function resetState ({ commit, dispatch }) {
  await dispatch('leaveAllOpenedSessions')
  commit('RESET_STATE')
}
